// The console's three layouts — same breakpoints as the app shell:
// mobile < 834 · tablet 834–1023 · desktop ≥ 1024.

import { useEffect, useState } from "react";

export type Breakpoint = "mobile" | "tablet" | "desktop";

const TABLET = "(min-width: 834px)";
const DESKTOP = "(min-width: 1024px)";

function current(): Breakpoint {
  if (window.matchMedia(DESKTOP).matches) return "desktop";
  return window.matchMedia(TABLET).matches ? "tablet" : "mobile";
}

export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(current);
  useEffect(() => {
    const queries = [window.matchMedia(TABLET), window.matchMedia(DESKTOP)];
    const update = () => setBp(current());
    queries.forEach((q) => q.addEventListener("change", update));
    return () => queries.forEach((q) => q.removeEventListener("change", update));
  }, []);
  return bp;
}
